import { AppRegistry } from "react-native";
import name from "./app.json";
import App from "./src/App.web";
import dayjs from 'dayjs';
import 'dayjs/locale/fr'
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {LocaleConfig} from 'react-native-calendars';

LocaleConfig.locales['fr'] = {
  monthNames: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre'
  ],
  monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
  dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
  today: "Aujourd'hui"
};

LocaleConfig.defaultLocale = 'fr';
dayjs.locale('fr')
dayjs.extend(customParseFormat);

import { enableExperimentalWebImplementation } from "react-native-gesture-handler";

enableExperimentalWebImplementation(true);

AppRegistry.registerComponent(name, () => {
  return App;
});

AppRegistry.runApplication(name, {
  initialProps: {},
  rootTag: document.getElementById("app-root"),
});
